/**
 * Choix de thème : système, clair ou sombre.
 *
 * Les tokens de `app.css` acceptent les deux chemins — `prefers-color-scheme`
 * et un forçage `<html data-theme>`. Ce module ne fait que poser l'attribut :
 * « système » le retire et laisse la media query décider.
 *
 * Persisté en localStorage plutôt qu'en IndexedDB : la valeur doit être lue
 * de façon synchrone au tout premier rendu, sinon l'app clignote en clair
 * avant de basculer.
 */

const KEY = "mailfox:theme";

export type ThemeChoice = "system" | "light" | "dark";

function read(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "light" || v === "dark" || v === "system") return v;
  } catch {
    // Navigation privée, cookies bloqués : on retombe sur le système.
  }
  return "system";
}

export const themeState = $state<{ choice: ThemeChoice }>({ choice: read() });

function apply(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", choice);
}

/** À appeler une fois au boot, avant le premier rendu si possible. */
export function initTheme(): void {
  apply(themeState.choice);
}

export function setTheme(choice: ThemeChoice): void {
  themeState.choice = choice;
  apply(choice);
  try {
    localStorage.setItem(KEY, choice);
  } catch {
    // Sans persistance on garde au moins le choix de la session.
  }
}
